import React from 'react';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Label,
  Progress,
  Alert,
  Badge,
} from 'reactstrap';
import ReactGA from 'react-ga4';
import img1 from '../../assets/images/logo2_x3.png';
import { ESPLoader, Transport } from 'esptool-js';

const sidebarBackground = {
  backgroundColor: '#313642',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom center',
};

const formBackground = {
  backgroundColor: '#414755',
};

const FLASH_BAUDRATE = 921600;
const CONSOLE_BAUDRATE = 115200;
const FLASH_SIZE = '16MB';
const TARGET_VERSION = '2.2';
const TARGET_VERSION_FULL = '2.2';

const ESP32_SERIAL_FILTERS = [
  { usbVendorId: 0x10c4, usbProductId: 0xea60 }, // Silicon Labs CP210x
];

const FIRMWARE_FILES = [
  {
    address: 0x17000,
    path: 'https://g2-support-materials.s3.us-west-2.amazonaws.com/Firmware/ota_data_initial.bin',
    name: 'ota_data_initial.bin',
  },
  {
    address: 0x20000,
    path: 'https://g2-support-materials.s3.us-west-2.amazonaws.com/Firmware/azena_glass2_production_2_2070.bin',
    name: 'azena_glass2_production_2_2070.bin',
  },
];

const EXPECTED_MIN_SIZES = {
  'ota_data_initial.bin': 8192,
  'azena_glass2_production_2_2070.bin': 1000000,
};

// const FIRMWARE_FILES = [
//   {
//     address: 0x17000,
//     path: '/firmware/ota_data_initial.bin',
//     name: 'ota_data_initial.bin',
//   },
//   {
//     address: 0x20000,
//     path: '/firmware/azena_glass2_production_2_2070.bin',
//     name: 'azena_glass2_production_2_2070.bin',
//   },
// ];

class G2FirmwareUpdate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      connecting: false,
      connected: false,
      flashing: false,
      monitoring: false,
      showAdvanced: false,
      chipName: '',
      flashStatus: '',
      customerStatus: 'Ready to connect your device.',
      error: '',
      progress: 0,
      selectedPortInfo: '',
      logLines: [],
      firmwareFilesLoaded: false,
      success: false,
      successMessage: '',
      showDriverHelp: false,
    };

    this.transport = null;
    this.esploader = null;
    this.device = null;

    this.monitorPort = null;
    this.monitorReader = null;
    this.monitorKeepReading = false;
    this.monitorTimeoutId = null;
  }

  // async componentDidMount() {
  //   ReactGA.pageview(window.location.pathname);
  //   this.appendLog('Firmware updater page loaded.');
  //
  //   if (!navigator.serial) {
  //     this.setState({
  //       customerStatus: 'This browser is not supported. Please use Chrome or Edge.',
  //     });
  //     this.appendLog('Web Serial is not available in this browser.');
  //     return;
  //   }
  //
  //   try {
  //     const port = await this.findPreferredPort();
  //     if (port) {
  //       this.appendLog('Previously approved device detected and ready to connect.');
  //       this.setState({
  //         customerStatus: 'Device detected. Click Connect Device to continue.',
  //       });
  //     } else {
  //       this.setState({
  //         customerStatus: 'Connect your device, then click Connect Device.',
  //       });
  //     }
  //   } catch (e) {
  //     this.appendLog(`Startup check skipped: ${e.message || e}`);
  //   }
  // }

  async componentDidMount() {
    ReactGA.pageview(window.location.pathname);
    this.appendLog('Firmware updater page loaded.');

    if (!navigator.serial) {
      this.setState({
        customerStatus: 'This browser is not supported. Please use Chrome or Edge.',
      });
      this.appendLog('Web Serial is not available in this browser.');
      return;
    }

    try {
      const port = await this.findPreferredPort();

      if (port) {
        this.appendLog('Previously approved device detected and ready to connect.');
        this.setState({
          customerStatus: 'Device detected. Click Connect and Update Device to continue.'
        });
      } else {
        this.setState({
          customerStatus: 'Connect your device, then click Connect and Update Device.'
        });
      }
    } catch (e) {
      this.appendLog(`Startup check skipped: ${e.message || e}`);
    }
  }

  // async componentDidMount() {
  //   ReactGA.pageview(window.location.pathname);
  //   this.appendLog('Firmware updater page loaded.');
  //
  //   // 1. Browser support check
  //   if (!navigator.serial) {
  //     this.setState({
  //       customerStatus: 'This browser is not supported. Please use Chrome or Edge.',
  //     });
  //     return;
  //   }
  //
  //   try {
  //     // 2. Driver / device presence check
  //     const ports = await navigator.serial.getPorts();
  //
  //     const hasCP210x = ports.some((port) => {
  //       const info = port.getInfo?.() || {};
  //       return info.usbVendorId === 0x10c4; // Silicon Labs
  //     });
  //
  //     if (!hasCP210x) {
  //       this.setCustomerStatus(
  //         'No device detected. If plugged in, install the CP210x driver and reconnect.'
  //       );
  //       this.appendLog('No CP210x device found (driver likely missing).');
  //       return;
  //     }
  //
  //     // 3. Your existing logic
  //     const port = await this.findPreferredPort();
  //
  //     if (port) {
  //       this.appendLog('Previously approved device detected and ready to connect.');
  //       this.setState({
  //         customerStatus: 'Device detected. Click Connect Device to continue.',
  //       });
  //     } else {
  //       this.setState({
  //         customerStatus: 'Device detected. Click Connect Device.',
  //       });
  //     }
  //
  //   } catch (e) {
  //     this.appendLog(`Startup check skipped: ${e.message || e}`);
  //   }
  // }

  componentWillUnmount() {
    this.stopMonitor();
    this.cleanupTransport();
  }

  appendLog = (message) => {
    const line = `[${new Date().toLocaleTimeString()}] ${message}`;
    this.setState((prev) => ({
      logLines: [...prev.logLines, line],
    }));
  };

  clearLog = () => {
    this.setState({ logLines: [] });
  };

  setCustomerStatus = (customerStatus) => {
    this.setState({ customerStatus });
  };

  terminal = {
    clean: () => {
      this.clearLog();
    },
    writeLine: (data) => {
      this.appendLog(String(data));
    },
    write: (data) => {
      this.appendLog(String(data));
    },
  };

  fetchBinaryFile = async (url) => {
    const response = await fetch(url, { cache: 'no-store' });

    if (!response.ok) {
      throw new Error(`Failed to load firmware file: ${url} (HTTP ${response.status})`);
    }

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    const arrayBuffer = await response.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);

    let preview = '';
    try {
      preview = new TextDecoder().decode(bytes.slice(0, 128)).toLowerCase();
    } catch (e) {
      preview = '';
    }

    const looksLikeHtml =
      contentType.includes('text/html') ||
      preview.includes('<!doctype') ||
      preview.includes('<html');

    if (looksLikeHtml) {
      throw new Error(`Firmware URL returned HTML instead of binary: ${url}`);
    }

    return bytes;
  };

  uint8ArrayToBinaryString = (bytes) => {
    let binary = '';
    const chunkSize = 0x8000;

    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode(...chunk);
    }

    return binary;
  };

  loadFirmwareFiles = async () => {
    this.appendLog('Loading firmware assets...');
    this.setCustomerStatus('Preparing the update files...');

    const loaded = await Promise.all(
      FIRMWARE_FILES.map(async (file) => {
        const bytes = await this.fetchBinaryFile(file.path);

        const minSize = EXPECTED_MIN_SIZES[file.name];
        if (minSize && bytes.length < minSize) {
          throw new Error(
            `${file.name} looks invalid. Expected at least ${minSize} bytes, got ${bytes.length}.`
          );
        }

        this.appendLog(`Loaded ${file.name} (${bytes.length} bytes)`);

        return {
          address: file.address,
          data: this.uint8ArrayToBinaryString(bytes),
          rawSize: bytes.length,
          name: file.name,
        };
      })
    );

    this.setState({ firmwareFilesLoaded: true });
    return loaded;
  };

  getPortLabel = (port) => {
    try {
      const info = port.getInfo?.() || {};
      const vendorId = info.usbVendorId
        ? `0x${info.usbVendorId.toString(16)}`
        : 'unknown';
      const productId = info.usbProductId
        ? `0x${info.usbProductId.toString(16)}`
        : 'unknown';

      return `Vendor ${vendorId} / Product ${productId}`;
    } catch {
      return 'USB serial device';
    }
  };

  findPreferredPort = async () => {
    const ports = await navigator.serial.getPorts();

    const matchingPort = ports.find((port) => {
      const info = port.getInfo?.() || {};
      return (
        info.usbVendorId === 0x10c4 &&
        info.usbProductId === 0xea60
      );
    });

    return matchingPort || null;
  };

  connectToPort = async (port) => {
    this.device = port;

    const portLabel = this.getPortLabel(port);
    this.appendLog(`Port selected: ${portLabel}`);

    this.transport = new Transport(port, true);
    this.esploader = new ESPLoader({
      transport: this.transport,
      baudrate: FLASH_BAUDRATE,
      terminal: this.terminal,
    });

    this.appendLog('Connecting to ESP device...');
    this.setCustomerStatus('Connecting to your device...');

    const chip = await this.esploader.main('default_reset');

    this.setState({
      connected: true,
      showDriverHelp: false,
      chipName: chip || 'ESP device detected',
      selectedPortInfo: portLabel,
      flashStatus: 'Connected',
      error: '',
      success: false,
      successMessage: '',
    });

    this.setCustomerStatus('Device connected. Starting update...');
    this.appendLog(`Connected successfully. Chip: ${chip || 'Unknown ESP chip'}`);
  };

  cleanupTransport = async () => {
    try {
      if (this.transport) {
        await this.transport.disconnect?.();
      }
    } catch (err) {
      console.warn('Transport cleanup error:', err);
    } finally {
      this.transport = null;
      this.esploader = null;
      this.device = null;
      this.setState({ connected: false });
    }
  };

  stopMonitor = async () => {
    this.monitorKeepReading = false;

    if (this.monitorTimeoutId) {
      clearTimeout(this.monitorTimeoutId);
      this.monitorTimeoutId = null;
    }

    try {
      if (this.monitorReader) {
        await this.monitorReader.cancel();
      }
    } catch (e) {
      // ignore
    }

    try {
      if (this.monitorReader) {
        this.monitorReader.releaseLock();
      }
    } catch (e) {
      // ignore
    }

    this.monitorReader = null;

    try {
      if (this.monitorPort) {
        await this.monitorPort.close();
      }
    } catch (e) {
      // ignore
    }

    this.monitorPort = null;

    if (this.state.monitoring) {
      this.appendLog('Serial monitor stopped.');
    }

    this.setState({ monitoring: false });
  };

  openMonitorOnExistingPort = async (port, triggerReset = true, autoStopMs = 6000) => {
    await this.stopMonitor();

    this.appendLog(`Opening serial monitor at ${CONSOLE_BAUDRATE} baud...`);
    this.setCustomerStatus('Finalizing the update and restarting your device...');

    this.monitorPort = port;
    await port.open({ baudRate: CONSOLE_BAUDRATE });

    const reader = port.readable.getReader();
    this.monitorReader = reader;
    this.monitorKeepReading = true;

    const decoder = new TextDecoder();

    this.setState({ monitoring: true });
    this.appendLog('Reading boot logs...');

    if (triggerReset) {
      setTimeout(async () => {
        try {
          this.appendLog('Triggering reset for boot log capture...');
          await port.setSignals({
            dataTerminalReady: false,
            requestToSend: true,
          });
          await new Promise((r) => setTimeout(r, 120));
          await port.setSignals({
            dataTerminalReady: false,
            requestToSend: false,
          });
          this.appendLog('Reset pulse sent.');
        } catch (e) {
          this.appendLog(`Reset pulse failed: ${e.message || e}`);
          this.appendLog('Press the RESET/EN button manually now.');
        }
      }, 300);
    }

    if (autoStopMs > 0) {
      this.monitorTimeoutId = setTimeout(async () => {
        this.monitorKeepReading = false;
        try {
          if (this.monitorReader) {
            await this.monitorReader.cancel();
          }
        } catch (e) {
          // ignore
        }
      }, autoStopMs);
    }

    try {
      while (this.monitorKeepReading) {
        const { value, done } = await reader.read();
        if (done) break;

        if (value) {
          const text = decoder.decode(value, { stream: true });
          if (text) this.appendLog(text);
        }
      }
    } finally {
      if (this.monitorTimeoutId) {
        clearTimeout(this.monitorTimeoutId);
        this.monitorTimeoutId = null;
      }

      try {
        if (this.monitorReader) {
          this.monitorReader.releaseLock();
        }
      } catch (e) {
        // ignore
      }

      try {
        if (this.monitorPort) {
          await this.monitorPort.close();
        }
      } catch (e) {
        // ignore
      }

      this.monitorReader = null;
      this.monitorPort = null;
      this.monitorKeepReading = false;
      this.setState({ monitoring: false });
    }
  };

  handleConnect = async () => {
    if (!navigator.serial) {
      this.setState({
        error: 'This browser does not support Web Serial. Use Chrome or Edge.',
      });
      return;
    }

    await this.stopMonitor();

    this.setState({
      connecting: true,
      connected: false,
      chipName: '',
      error: '',
      flashStatus: '',
      progress: 0,
      firmwareFilesLoaded: false,
      success: false,
      successMessage: '',
    });

    try {
      this.appendLog('Looking for previously approved ESP32 serial devices...');
      this.setCustomerStatus('Looking for your device...');

      let port = await this.findPreferredPort();

      if (port) {
        this.appendLog('Found previously approved ESP32 device. Connecting automatically...');
        this.setCustomerStatus('Device found. Connecting automatically...');
      } else {
        this.appendLog('No previously approved ESP32 device found. Prompting for port selection...');
        this.setCustomerStatus('Please choose your connected device to continue.');

        try {
          port = await navigator.serial.requestPort({
            filters: ESP32_SERIAL_FILTERS,
          });
        } catch (err) {
          if (err?.name === 'NotFoundError') {
            this.setState({
              error: '',
              showDriverHelp: true
            });
            this.setCustomerStatus(
              'No compatible device was selected. If your device is plugged in but does not appear, install the CP210x driver and try again.'
            );
            this.appendLog('No device selected. Driver may be missing, or the device/cable may not be ready.');
            return;
          }
          throw err;
        }
      }

      await this.connectToPort(port);

      await this.handleUpdate();

    } catch (err) {
      console.error(err);
      this.appendLog(`Connection failed: ${err.message || String(err)}`);

      await this.cleanupTransport();

      this.setState({
        connected: false,
        chipName: '',
        error: err.message || 'Failed to connect and update device.',
        flashStatus: '',
      });

      this.setCustomerStatus(
        'Unable to connect. Please check the USB cable, reconnect the device, close any app using the port, and install the CP210x driver if needed.'
      );
    } finally {
      this.setState({ connecting: false });
    }
  };

  handleDisconnect = async () => {
    await this.stopMonitor();
    await this.cleanupTransport();

    this.setState({
      connected: false,
      connecting: false,
      flashing: false,
      monitoring: false,
      chipName: '',
      flashStatus: 'Disconnected.',
      selectedPortInfo: '',
      progress: 0,
      firmwareFilesLoaded: false,
    });

    this.setCustomerStatus('Device disconnected.');
    this.appendLog('Disconnected from device.');
  };

  handleUpdate = async () => {
    if (!this.esploader || !this.device) {
      this.setState({ error: 'No connected device found.' });
      this.setCustomerStatus('Please connect your device before updating.');
      return;
    }

    this.setState({
      flashing: true,
      error: '',
      flashStatus: 'Preparing update...',
      progress: 0,
      success: false,
      successMessage: '',
    });

    try {
      const firmwareFiles = await this.loadFirmwareFiles();
      const totalBytes = firmwareFiles.reduce((sum, file) => sum + file.rawSize, 0);

      this.appendLog(`Starting flash of ${firmwareFiles.length} files...`);
      this.appendLog(`Total bytes: ${totalBytes}`);
      this.setCustomerStatus(`Updating your device to v${TARGET_VERSION}... Please keep it connected.`);

      await this.esploader.writeFlash({
        fileArray: firmwareFiles.map((file) => ({
          address: file.address,
          data: file.data,
        })),
        flashMode: 'dio',
        flashFreq: '40m',
        flashSize: FLASH_SIZE,
        eraseAll: false,
        compress: true,
        reportProgress: (fileIndex, written) => {
          const bytesBeforeCurrent = firmwareFiles
            .slice(0, fileIndex)
            .reduce((sum, file) => sum + file.rawSize, 0);

          const overallWritten = bytesBeforeCurrent + written;
          const overallPercent = totalBytes
            ? Math.min(100, Math.round((overallWritten / totalBytes) * 100))
            : 0;

          this.setState({
            progress: overallPercent,
            flashStatus: `Updating device... ${overallPercent}%`,
          });

          if (overallPercent < 100) {
            this.setCustomerStatus(`Updating your device... ${overallPercent}% complete.`);
          }
        },
      });

      await this.esploader.after('hard_reset');
      this.appendLog('Hard reset issued.');
      await new Promise((r) => setTimeout(r, 500));

      try {
        if (this.transport) {
          await this.transport.disconnect();
        }
        this.appendLog('Serial transport closed.');
      } catch (e) {
        this.appendLog(`Transport close warning: ${e.message || e}`);
      } finally {
        this.transport = null;
        this.esploader = null;
      }

      const existingPort = this.device;
      this.device = null;

      this.setState({
        connected: false,
        flashing: false,
        progress: 100,
        flashStatus: 'Update complete. Restarting device...',
      });

      this.appendLog('Flash complete.');
      this.appendLog('Opening boot log monitor automatically...');

      await new Promise((r) => setTimeout(r, 500));
      await this.openMonitorOnExistingPort(existingPort, true, 5000);

      await this.stopMonitor();

      this.setState({
        success: true,
        successMessage: `Update to v${TARGET_VERSION} Successful`,
        flashStatus: `Update to v${TARGET_VERSION} Successful`,
        selectedPortInfo: '',
        chipName: '',
      });

      this.setCustomerStatus(`Your device has been updated to v${TARGET_VERSION}. It is now safe to unplug it.`);
      this.appendLog(`Update to v${TARGET_VERSION_FULL} completed successfully.`);

      try {
        if (existingPort) {
          await existingPort.close();
        }
      } catch (e) {
        // ignore
      }

      await this.cleanupTransport();
    } catch (err) {
      console.error(err);
      this.appendLog(`Update failed: ${err.message || String(err)}`);

      this.setState({
        error: err.message || 'Device update failed.',
        flashStatus: 'Update failed.',
        flashing: false,
        success: false,
        successMessage: '',
      });

      this.setCustomerStatus('The update did not complete. Please disconnect the device, reconnect it, and try again.');
    }
  };

  renderStatusBadge() {
    const { connecting, connected, flashing, monitoring, success } = this.state;

    if (flashing) {
      return <Badge color="warning">Updating</Badge>;
    }

    if (monitoring) {
      return <Badge color="info">Restarting</Badge>;
    }

    if (connecting) {
      return <Badge color="info">Connecting</Badge>;
    }

    if (connected) {
      return <Badge color="success">Connected</Badge>;
    }

    if (success) {
      return <Badge color="success">Complete</Badge>;
    }

    return <Badge color="secondary">Ready</Badge>;
  }

  render() {
    const {
      connecting,
      connected,
      flashing,
      monitoring,
      showAdvanced,
      chipName,
      flashStatus,
      customerStatus,
      error,
      progress,
      selectedPortInfo,
      logLines,
      success,
      successMessage,
    } = this.state;

    const isBusy = connecting || flashing || monitoring;

    return (
      <div>
        <div
          className="auth-wrapper d-flex no-block justify-content-center align-items-center"
          style={sidebarBackground}
        >
          <div className="auth-box-2 on-sidebar" style={formBackground}>
            <div id="firmwareUpdateForm">

              <Row>
                <Col xs="1" md="3" />
                <Col xs="10" md="6">
                  <div className="logo">
                    <span className="db mb-5">
                      <img style={{ width: '100%' }} src={img1} alt="logo" />
                    </span>
                    <h3 className="mt-5 mb-3 text-light text-center">
                      Device Update
                    </h3>
                    <h5 className="font-medium mb-3 text-light text-center">
                      Connect your device and install the latest update.
                    </h5>
                  </div>
                </Col>
                <Col xs="1" md="3" />
              </Row>

							<Row className="mb-3">
								<Col xs="1" md="4" />
							  <Col xs="10" md="4" className="text-center">
							    <Button
							      size="sm"
							      color="light"
							      outline
							      onClick={() => this.setState({ showAdvanced: !showAdvanced })}
							    >
							      {showAdvanced ? 'Hide Advanced' : 'Show Advanced'}
							    </Button>
							  </Col>
							  <Col xs="1" md="4" />
							</Row>

              {this.state.showDriverHelp && (
                <Row className="mb-3">
                  <Col xs="12">
                    <Alert color="warning" style={{ textAlign: 'center' }}>
                      <div style={{ fontWeight: 600, marginBottom: '6px' }}>
                        Driver may be required to detect your device
                      </div>

                      <div style={{ fontSize: '14px' }}>
                        If your device does not appear when connecting, install the CP210x driver and try again.
                      </div>

                      <div style={{ marginTop: '10px' }}>
                        <a
                          href="/guides/Gemini_EVO_Installation_Guide.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginRight: '15px', fontWeight: 500, color: '#fdae1e' }}
                        >
                          Installation Guide
                        </a>

                        <a
                          href="https://g2-support-materials.s3.us-west-2.amazonaws.com/Drivers/CP210x_VCP_Windows.zip"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ fontWeight: 500, color: '#fdae1e' }}
                        >
                          Download Driver
                        </a>
                      </div>
                    </Alert>
                  </Col>
                </Row>
              )}

              <Row>
                <Col className="p-4" xs="12">
                  <div
                    className="text-light text-center mb-3"
                    style={{ fontSize: '16px', minHeight: '24px' }}
                  >
                    {customerStatus}
                  </div>

                  {success && (
                    <div
                      className="text-center mb-4"
                      style={{
                        color: '#4bd06b',
                        fontWeight: 700,
                        fontSize: '22px',
                      }}
                    >
                      {successMessage}
                    </div>
                  )}

                  {showAdvanced && (
                    <div className="text-light pl-3 mb-3" style={{ fontSize: '13px' }}>
                      <div>Target version: v{TARGET_VERSION}</div>
                      <div>Flash size: {FLASH_SIZE}</div>
                      <div>Baud rate: {FLASH_BAUDRATE}</div>
                    </div>
                  )}
                </Col>
              </Row>

              <Row>
                <Col className="mb-2" xs="12" md={showAdvanced ? '6' : '12'}>
                  <Card style={{ backgroundColor: '#586072' }}>
                    <CardBody>
                      <Row className="mb-3">
                        <Col xs="5">
                          <Label className="text-light" style={{ fontSize: '16px' }}>
                            Status:
                          </Label>
                        </Col>
                        <Col xs="7" className="text-right">
                          {this.renderStatusBadge()}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col xs="5">
                          <Label className="text-light" style={{ fontSize: '16px' }}>
                            Device:
                          </Label>
                        </Col>
                        <Col xs="7">
                          <div className="text-light" style={{ fontSize: '14px' }}>
                            {connected ? 'Connected' : success ? 'Updated' : 'Not connected'}
                          </div>
                        </Col>
                      </Row>

                      {showAdvanced && (
                        <>
                          <Row className="mb-3">
                            <Col xs="5">
                              <Label className="text-light" style={{ fontSize: '16px' }}>
                                Port:
                              </Label>
                            </Col>
                            <Col xs="7">
                              <div className="text-light" style={{ fontSize: '14px' }}>
                                {selectedPortInfo || 'Not selected'}
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col xs="5">
                              <Label className="text-light" style={{ fontSize: '16px' }}>
                                Chip:
                              </Label>
                            </Col>
                            <Col xs="7">
                              <div className="text-light" style={{ fontSize: '14px' }}>
                                {chipName || 'Not connected'}
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}

                      <Row className="mb-3">
                        <Col xs="12">
                          <Button
                            style={{ width: '100%' }}
                            color="primary"
                            onClick={this.handleConnect}
                            disabled={connecting || flashing || monitoring}
                          >
                            {connecting ? 'Connecting...' : 'Connect and Update Device'}
                          </Button>
                        </Col>
                      </Row>

                      {
                        // <Row className="mb-3">
                        //   <Col xs="12">
                        //     <Button
                        //       style={{ width: '100%' }}
                        //       color="warning"
                        //       onClick={this.handleUpdate}
                        //       disabled={!connected || flashing || connecting || monitoring}
                        //     >
                        //       {flashing || monitoring ? 'Updating...' : 'Update Device'}
                        //     </Button>
                        //   </Col>
                        // </Row>
                      }

                      <Row className="mb-2">
                        <Col xs="12">
													<Button
														style={{ width: '100%' }}
														color="secondary"
														onClick={this.handleDisconnect}
                            disabled={isBusy || !connected}
														>
														Disconnect
													</Button>
                        </Col>
                      </Row>

                      {(flashStatus || flashing || monitoring) && (
                        <Row className="mt-4">
                          <Col xs="12">
                            <Label className="text-light">Progress</Label>
                            <Progress value={progress} className="mb-2" />
                            <div className="text-light" style={{ fontSize: '13px' }}>
                              {flashStatus}
                            </div>
                          </Col>
                        </Row>
                      )}

                      {error && (
                        <Row className="mt-3">
                          <Col xs="12">
                            <Alert color="danger" className="mb-0">
                              {error}
                            </Alert>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                {showAdvanced && (
                  <Col className="mb-2" xs="12" md="6">
                    <Card style={{ backgroundColor: '#586072' }}>
                      <CardBody>
                        <Row className="mb-2">
                          <Col xs="12">
                            <Label className="text-light" style={{ fontSize: '16px' }}>
                              Advanced Console
                            </Label>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <div
                              style={{
                                backgroundColor: '#1f2430',
                                color: '#d7dde8',
                                minHeight: '360px',
                                maxHeight: '360px',
                                overflowY: 'auto',
                                padding: '12px',
                                borderRadius: '6px',
                                fontFamily: 'monospace',
                                fontSize: '12px',
                                whiteSpace: 'pre-wrap',
                              }}
                            >
                              {logLines.length
                                ? logLines.join('\n')
                                : 'No log output yet.'}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default G2FirmwareUpdate;
